import { KoobMap as Map } from '@koob/maps';
import MapMarker from 'components/Hotel/MapMarker';
import React, { useState } from 'react';
import { useDeepCompareEffect } from 'react-use';

const containerStyle = {
  width: '100%',
  height: '200px',
  marginTop: '30px',
  borderRadius: '15px',
};

const KoobMap = ({ markers, style }) => {
  const [map, setMap] = useState();

  useDeepCompareEffect(() => {
    if (!Boolean(map) || markers.length === 0) {
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();
    markers
      .filter(marker => Boolean(marker?.lat) || Boolean(marker?.lon))
      .forEach(marker =>
        bounds.extend(
          new window.google.maps.LatLng(
            parseFloat('' + marker?.lat),
            parseFloat('' + marker?.lon),
          ),
        ),
      );
    if (markers.length === 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(12);
    } else {
      map.fitBounds(bounds);
    }
  }, [markers, map]);

  return (
    <Map
      style={{ overflow: 'hidden', ...(style ?? containerStyle) }}
      maxZoom={20}
      zoom={8}
      onLoad={setMap}
      onUnmount={() => setMap(null)}
    >
      {(markers ?? []).map((marker, index) => (
        <MapMarker
          key={index}
          lat={marker?.lat}
          lon={marker?.lon}
          name={marker?.name}
          address={marker?.address}
          title={marker?.title}
          Icon={marker?.icon}
        ></MapMarker>
      ))}
    </Map>
  );
};

export default KoobMap;
